import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./PasswordReset.css";
import {
  fontFamily,
  forgotSearchBoxStyle,
  loginButtonStyle,
  loginButtonWithoutColorStyle,
} from "../components/Constants/constants";
import { BASE_URL } from "../App_Settings/app_settings";
import { InputBase } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { InputAdornment, IconButton } from "@mui/material";
import InstaColors from "../components/Constants/constants";

const PasswordReset = () => {
  const history = useHistory();
  const [screen, setScreen] = useState("email"); // 'email', 'verify', 'reset'
  const [email, setEmail] = useState("");
  const [enteredAccessKey, setEnteredAccessKey] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  let resettKey;

  // Password requirement states
  const [passwordRequirements, setPasswordRequirements] = useState({
    length: false,
    uppercase: false,
    number: false,
    specialChar: false,
  });

  const checkPasswordRequirements = (password) => {
    const requirements = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[!@#$%^&*]/.test(password),
    };
    setPasswordRequirements(requirements);

    // Return true if all requirements are met
    return (
      requirements.length &&
      requirements.uppercase &&
      requirements.number &&
      requirements.specialChar
    );
  };

  const validatePassword = () => {
    const newErrors = {};
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    if (!passwordRegex.test(newPassword)) {
      newErrors.password = "Password must meet all requirements";
    }
    if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); // Clear previous errors

    // Validate email
    if (!email || email.trim() === "") {
      setErrors({
        email: "Please enter your email address.",
      });
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrors({
        email: "Please enter a valid email address.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/Users/PasswordResetKey?emailId=${email}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      setLoading(false);
      console.log(response);
      if (response.ok) {
        alert(
          "A reset access key has been sent to your registered email address. Please check your inbox."
        );

        setScreen("verify");
      } else {
        alert("Failed to send access key. Please try again.");
      }
    } catch (error) {
      setLoading(false);
      alert("An error occurred. Please try again later.");
      console.error(error);
    }
  };

  const handleVerifySubmit = async (e) => {
    e.preventDefault();
    setErrors({}); // Clear previous errors

    // Validate access key length
    if (!enteredAccessKey || enteredAccessKey.trim().length < 15) {
      setErrors({
        otp: "Please enter the access key sent to your email.",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${BASE_URL}/Users/ValidateResetKey?emailId=${email}&passwordResetKey=${enteredAccessKey}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      setLoading(false);

      if (response.ok && responseData === true) {
        // Key verification successful
        setErrors({});
        setScreen("reset");
      } else if (response.ok && responseData === false) {
        // Key verification failed - invalid Key
        setErrors({
          otp: "Invalid Key. Please enter the correct verification code sent to your email.",
        });
      } else {
        // Server error or other issues
        const errorMessage = responseData?.message || "Failed to verify Key. Please try again.";
        setErrors({
          otp: errorMessage,
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Key verification error:", error);
      setErrors({
        otp: "Network error occurred. Please check your connection and try again.",
      });
    }
  };
  const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();
    if (!validatePassword()) {
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/Users/ResetPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: email, password: newPassword }),
      });

      setLoading(false);
      if (response.ok) {
        alert("Password reset successful!");
        history.push("/");
      } else {
        alert("Failed to reset password. Please try again.");
      }
    } catch (error) {
      setLoading(false);
      alert("An error occurred. Please try again.");
      console.error("Error:", error);
    }
  };
  const handleBack = () => {
    history.push({
      pathname: "/login",
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "100vh",
        backgroundImage: "url(/background.png)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <div
        style={{
          width: "534px",
          height: "550px",
          margin: "auto",
          background: "white",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          padding: 20,
          borderRadius: 8,
        }}
      >
        {/* {loading && <p>Loading...</p>} */}

        {screen === "email" && (
          <>
            <h3 style={{ color: "#2aa7e0", fontFamily: fontFamily }}>Forgot Password</h3>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 40,
                alignItems: "flex-start",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontFamily: fontFamily,
                  fontWeight: 400,
                  color: "#666666",
                  marginBottom: 10,
                }}
                htmlFor="user_pass"
              >
                Email
              </label>
              <InputBase
                type="email"
                placeholder="Enter email"
                value={email}
                style={forgotSearchBoxStyle}
                onChange={(e) => {
                  setEmail(e.target.value);
                  // Clear error when user starts typing
                  if (errors.email) {
                    setErrors((prev) => ({ ...prev, email: "" }));
                  }
                }}
                required
              />

              {/* Display email error message */}
              {errors.email && (
                <div
                  style={{
                    color: "#d32f2f",
                    fontSize: "14px",
                    fontFamily: fontFamily,
                    marginTop: "8px",
                    padding: "8px 12px",
                    // backgroundColor: "#ffebee",
                    // border: "1px solid #ffcdd2",
                    borderRadius: "4px",
                    textAlign: "center",
                    maxWidth: "430px",
                  }}
                >
                  {errors.email}
                </div>
              )}
            </div>
            {/* <p
              style={{
                marginTop: 8,
                color: "#2aa7e0",
                fontSize: "13px",
                marginRight: 33,
                fontWeight: 300,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                cursor: "pointer",
                fontFamily: fontFamily,
                marginLeft: "auto",
                marginBottom: 150,
              }}
              onClick={() => {
                if (!email) {
                  alert("Please enter your email address before proceeding.");
                  return;
                }
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                  alert("Please enter a valid email address.");
                  return;
                }
                setScreen("verify");
              }}
            >
              Already have an access key?
            </p> */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
                marginTop: "50px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                onClick={handleBack}
                style={loginButtonWithoutColorStyle}
                type="submit"
                name="wp-submit"
                sx={{ textDecoration: "none" }}
                id="wp-submit"
              >
                Back
              </div>
              <div
                onClick={handleEmailSubmit}
                style={loginButtonStyle}
                type="submit"
                name="wp-submit"
                sx={{ textDecoration: "none" }}
                id="wp-submit"
              >
                Submit
              </div>
            </div>

            {/* <p style={{ paddingTop: 50 }}>
              Please enter your email. We will send an access key to your email address.
            </p> */}
          </>
        )}

        {screen === "verify" && (
          <>
            <h3 style={{ color: "#2aa7e0", fontFamily: fontFamily }}>Verify Access Key</h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 40,
                alignItems: "flex-start",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontFamily: fontFamily,
                  fontWeight: 400,
                  color: "#666666",
                  marginBottom: 10,
                }}
                htmlFor="user_pass"
              >
                Access Key
              </label>
              <InputBase
                type="text"
                placeholder="Enter access key"
                value={enteredAccessKey}
                style={forgotSearchBoxStyle}
                onChange={(e) => {
                  setEnteredAccessKey(e.target.value);
                  // Clear error when user starts typing
                  if (errors.otp) {
                    setErrors((prev) => ({ ...prev, otp: "" }));
                  }
                }}
                required
              />

              {/* Display OTP error message */}
              {errors.otp && (
                <div
                  style={{
                    color: "#d32f2f",
                    fontSize: "14px",
                    fontFamily: fontFamily,
                    marginTop: "8px",
                    padding: "8px 12px",
                    // backgroundColor: "#ffebee",
                    // border: "1px solid #ffcdd2",
                    borderRadius: "4px",
                    textAlign: "center",
                    maxWidth: "430px",
                  }}
                >
                  {errors.otp}
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                marginTop: "50px",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                onClick={() => {
                  setScreen("email");
                }}
                style={loginButtonWithoutColorStyle}
                type="submit"
                name="wp-submit"
                sx={{ textDecoration: "none" }}
                id="wp-submit"
              >
                Back
              </div>
              <div
                onClick={loading ? null : handleVerifySubmit}
                style={{
                  ...loginButtonStyle,
                  backgroundColor: loginButtonStyle.backgroundColor,
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.7 : 1,
                }}
                type="submit"
                name="wp-submit"
                sx={{ textDecoration: "none" }}
                id="wp-submit"
              >
                {loading ? "Verifying..." : "Verify Key"}
              </div>
            </div>

            {/* <p style={{ paddingTop: 50 }}>
              Please submit the access key that you received in your email.
            </p> */}
          </>
        )}

        {screen === "reset" && (
          <>
            <h3 style={{ color: "#2aa7e0" }}>Create New Password</h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 30,
                alignItems: "flex-start",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontFamily: fontFamily,
                  fontWeight: 400,
                  color: "#666666",
                  marginBottom: 10,
                }}
                htmlFor="user_pass"
              >
                New Password
              </label>
              <InputBase
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password"
                value={newPassword}
                style={forgotSearchBoxStyle}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  checkPasswordRequirements(e.target.value);
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <Visibility
                          style={{
                            fontSize: 24,
                            marginRight: 4,
                            color: InstaColors.primary,
                          }}
                        />
                      ) : (
                        <VisibilityOff
                          style={{
                            fontSize: 24,
                            marginRight: 4,
                            color: InstaColors.primary,
                          }}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                required
              />
              {/* Only show password requirements when user has started typing and requirements are not all met */}
              {newPassword.length > 0 &&
                !(
                  passwordRequirements.length &&
                  passwordRequirements.uppercase &&
                  passwordRequirements.number &&
                  passwordRequirements.specialChar
                ) && (
                  <div style={{ width: 450, marginLeft: "auto", marginRight: "auto" }}>
                    <div className="password-requirements">
                      <div className="requirement">
                        {passwordRequirements.length ? (
                          <CheckCircle
                            style={{
                              color: "#4CAF50",
                              fontSize: 20,
                              marginRight: 8,
                            }}
                          />
                        ) : (
                          <span
                            style={{
                              color: errors.password ? "red" : "#666",
                              marginRight: 8,
                              marginLeft: 6,
                            }}
                          >
                            •
                          </span>
                        )}
                        <span
                          style={{
                            color: passwordRequirements.length
                              ? "#4CAF50"
                              : errors.password
                                ? "red"
                                : "#666",
                          }}
                        >
                          At least 8 characters
                        </span>
                      </div>
                      <div className="requirement">
                        {passwordRequirements.uppercase ? (
                          <CheckCircle
                            style={{
                              color: "#4CAF50",
                              fontSize: 20,
                              marginRight: 8,
                            }}
                          />
                        ) : (
                          <span
                            style={{
                              color: errors.password ? "red" : "#666",
                              marginRight: 8,
                              marginLeft: 6,
                            }}
                          >
                            •
                          </span>
                        )}
                        <span
                          style={{
                            color: passwordRequirements.uppercase
                              ? "#4CAF50"
                              : errors.password
                                ? "red"
                                : "#666",
                          }}
                        >
                          At least 1 uppercase letter
                        </span>
                      </div>
                      <div className="requirement">
                        {passwordRequirements.number ? (
                          <CheckCircle
                            style={{
                              color: "#4CAF50",
                              fontSize: 20,
                              marginRight: 8,
                            }}
                          />
                        ) : (
                          <span
                            style={{
                              color: errors.password ? "red" : "#666",
                              marginRight: 8,
                              marginLeft: 6,
                            }}
                          >
                            •
                          </span>
                        )}
                        <span
                          style={{
                            color: passwordRequirements.number
                              ? "#4CAF50"
                              : errors.password
                                ? "red"
                                : "#666",
                          }}
                        >
                          At least 1 number
                        </span>
                      </div>
                      <div className="requirement">
                        {passwordRequirements.specialChar ? (
                          <CheckCircle
                            style={{
                              color: "#4CAF50",
                              fontSize: 20,
                              marginRight: 8,
                            }}
                          />
                        ) : (
                          <span
                            style={{
                              color: errors.password ? "red" : "#666",
                              marginRight: 8,
                              marginLeft: 6,
                            }}
                          >
                            •
                          </span>
                        )}
                        <span
                          style={{
                            color: passwordRequirements.specialChar
                              ? "#4CAF50"
                              : errors.password
                                ? "red"
                                : "#666",
                          }}
                        >
                          At least 1 special character (!@#$%^&*)
                        </span>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 30,
                alignItems: "flex-start",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontFamily: fontFamily,
                  fontWeight: 400,
                  color: "#666666",
                  marginBottom: 10,
                }}
                htmlFor="user_pass"
              >
                Confirm Password
              </label>
              <InputBase
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Enter confirm password"
                value={confirmPassword}
                style={forgotSearchBoxStyle}
                onChange={(e) => setConfirmPassword(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      {showConfirmPassword ? (
                        <Visibility
                          style={{
                            fontSize: 24,
                            marginRight: 4,
                            color: InstaColors.primary,
                          }}
                        />
                      ) : (
                        <VisibilityOff
                          style={{
                            fontSize: 24,
                            marginRight: 4,
                            color: InstaColors.primary,
                          }}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                required
              />
              {errors.confirmPassword && (
                <span style={{ color: "red", marginTop: 8, textAlign: "center" }}>
                  {errors.confirmPassword}
                </span>
              )}
            </div>
            <div
              style={{
                display: "flex",
                marginTop: 30,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                onClick={handlePasswordResetSubmit}
                style={loginButtonStyle}
                type="submit"
                name="wp-submit"
                sx={{ textDecoration: "none" }}
                id="wp-submit"
              >
                Submit
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PasswordReset;
